"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiRecourtCredit = void 0;
exports.ESubScpiRecourtCredit = {
    oui: "oui",
    non: "non",
    neSaisPas: "neSaisPas",
};
